module.exports = __webpack_public_path__ + "img/sale-thumbnail.a9098544.png";